module.exports = __webpack_public_path__ + "img/cuba.5e8ae742.svg";